import { render } from "./ReportDoc.vue?vue&type=template&id=0836fba6&scoped=true"
import script from "./ReportDoc.vue?vue&type=script&lang=js"
export * from "./ReportDoc.vue?vue&type=script&lang=js"

import "./ReportDoc.vue?vue&type=style&index=0&id=0836fba6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0836fba6"]])

export default __exports__